import fetch from '@/utils/fetch'

// 列表接口
export const afterSaleList = '/aftersales/setting/reason/list'

// 创建/更新
export function aftersalesSettingReason (data) {
  return fetch({
    url: '/aftersales/setting/reason',
    method: 'post',
    data
  })
}

// 获取售后原因设置详情
export function aftersalesSettingReasonDetail (data) {
  return fetch({
    url: '/aftersales/setting/reason/detail',
    method: 'get',
    params: data
  })
}

// 删除售后原因
export function deleteAftersalesSettingReason (data) {
  return fetch({
    url: '/aftersales/setting/reason',
    method: 'delete',
    params: data
  })
}